export class PostPutTemplateRequest {
    public templateName: string;
    public templateDescription: string;
    public isActive: boolean;
    public listIdHealthUnit: number;
}